import { PaletteMode, SimplePaletteColorOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { infoColor } from './status/info';

export const info = (mode: PaletteMode, opts: GetThemeOptions): SimplePaletteColorOptions => {
  const color = infoColor(mode, opts);

  return {
    main: color.main,
    light: mode === 'light' ? color.lowContrast : color.highContrast,
    dark: mode === 'light' ? color.highContrast : color.lowContrast,
  };
};
